
let inject = [
  '$scope',
  'ServiceOrdersService',
  '$state',
  '$rootScope',
  'SharedService',
  '$timeout',
  'ngAuthSettings',
  'SessionService',
  'NgTableParams',
  '$uibModal'
];
class ServiceOrdersController{
  constructor ($scope,
               ServiceOrdersService,
               $state,
               $rootScope,
               SharedService,
               $timeout,
               ngAuthSettings,
               SessionService,
               NgTableParams,
               $uibModal) {

    this.$state = $state;
    this.SessionService = SessionService;
    this.ngAuthSettings = ngAuthSettings;
    this.NgTableParams = NgTableParams;
    // this.$scope = $scope;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.ServiceOrdersService = ServiceOrdersService;
    this.$uibModal = $uibModal;
    this.SharedService = SharedService;

    this.serviceOrdersList = null;
    this.stateServiceOrders = {};
    this.ngTableConfigServiceOrders = null;
    this.ngTableColsServiceOrders = null;

    this.serviceOrderDetail = null;
    this.stateServiceOrderDetail = {};
    this.ngTableConfigServiceOrderDetail = null;
    this.ngTableColsServiceOrderDetail = null;

    this.wachingDetailServiceOrder = false;

    this.payment = {};
    this.payment.recaudo = 0;
    this.payment.recaudo_total = 0;
  }

  $onInit(){
    this.getServiceOrdersHead();
  }

  getServiceOrdersHead(){

    this.stateServiceOrders.loading = true;
    this.wachingDetailServiceOrder = false;
    this.$timeout(()=>{
      if(this.serviceOrdersList && this.serviceOrdersList.length > 0){
        this.stateServiceOrders.loading = false;
        this.stateServiceOrders.loaded = true;
      }else{
        this.ServiceOrdersService.getServiceOrdersHead().then((response) => {
          this.stateServiceOrders.loading = false;
          this.stateServiceOrders.loaded = true;
          this.serviceOrdersList = response;
          this.serviceOrdersList.forEach((value, index)=>{
            value.valor_doc = parseInt(value.total);
            value.valor_pendiente = parseInt(value.total);
            value.valor_pagar_hoy = 0;
            value.valor_pagar_hoy_before = 0;
            this.payment.recaudo += value.valor_pendiente;
            value.type = "Cotización";
          });
          console.log("cotizaciones cabecera " + JSON.stringify(response));
          this.initNgTableServiceOrders();
        }).catch((reason) => {
          this.stateServiceOrders.loading = false;
          this.stateServiceOrders.loaded = true;
          this.stateServiceOrders.error = true;
        });
      }

    }, 1000);
  }

  changeValor(row){
    let valorServiceOrder = parseInt(row.valor_pagar_hoy.replace(/,/g, ''));
    if(valorServiceOrder > row.valor_pendiente){
      row.valor_pagar_hoy = row.valor_pendiente;
      valorServiceOrder = row.valor_pendiente;
    }
    this.payment.recaudo_total -= row.valor_pagar_hoy_before;
    this.payment.recaudo_total += valorServiceOrder;

    row.valor_pagar_hoy_before = valorServiceOrder;
  }

  activateServiceOrder(row){
    if(row.activate){
      row.valor_pagar_hoy = row.valor_pendiente;
      row.valor_pagar_hoy_before = row.valor_pendiente;
      this.payment.recaudo_total += row.valor_pendiente;

    }else{
      this.payment.recaudo_total -= row.valor_pagar_hoy_before;
      row.valor_pagar_hoy = 0;
      row.valor_pagar_hoy_before = 0;
    }

  }

  initNgTableServiceOrders() {
    /**
     * name:                           "NCN-000024"
     * type:                             "Lorem Ipsum"
     * fecha_cotizacion:                 "2016-09-14"
     * validez_cotizacion:               "2016-09-14"
     * assigned_user_name:               "Lorem Ipsum"
     * valor_saldo:                      "0.0000"
     * valor_pendiente:                  "0.0000"
     * valor_pagar_hoy:                  "0.0000"
     * total:                            "0.0000"
     */
    this.ngTableColsServiceOrders = [
      {
        field: "name",
        title: "No.",
        sortable: "name",
        filter: { "name": "text" },
        show: true
      },
      {
        field: "tipo_orden",
        title: "Tipo",
        sortable: "tipo_orden",
        filter: { "tipo_orden": "text" },
        show: true
      },
      {
        field: "date_entered",
        title: "F. Creación",
        sortable: "date_entered",
        filter: { "date_entered": "date" },
        show: true
      },
      {
        field: "fecha_ejecucion",
        title: "F. Ejecución",
        sortable: "fecha_ejecucion",
        filter: { "fecha_ejecucion": "date" },
        show: true
      },
      {
        field: "assigned_user_name",
        title: "Vendedor",
        sortable: "assigned_user_name",
        filter: { "assigned_user_name": "text" },
        show: true
      },
      {
        field: "subtotal",
        title: "Subtotal",
        sortable: "subtotal",
        filter: { "subtotal": "text" },
        show: true
      },
      {
        field: "impuestos",
        title: "Impuestos",
        sortable: "impuestos",
        filter: { "impuestos": "text" },
        show: true
      },
      {
        field: "valor_doc",
        title: "Vr. Doc.",
        sortable: "valor_doc",
        filter: { "valor_doc": "text" },
        show: true
      },
      {
        field: "valor_pagar_hoy",
        title: "Vr. a pagar hoy",
        show: true
      },
      {
        field: "selection",
        title: "",
        show: true
      },
      {
        field: "actions",
        title: "",
        show: true
      }
    ];

    let initialParams = {
      count: 20,
      sorting: { date_entered: "desc" }
    };

    let initialSettings = {
      counts: [5, 10, 20],
      paginationMaxBlocks: 8,
      paginationMinBlocks: 2,
      dataset: this.serviceOrdersList
    };

    this.ngTableConfigServiceOrders = new this.NgTableParams(initialParams, initialSettings);
  }

  getServiceOrderDetail(numberDocument){
  }

}

ServiceOrdersController.$inject = inject;

export default ServiceOrdersController;




/** WEBPACK FOOTER **
 ** ./www/components/payments-advances/service-orders/service-orders.controller.js
 **/